import "@/App.css";
import "@/styles/taandem.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/context/ContentContext";
import Landing from "@/pages/Landing";
import CaseDetail from "@/pages/CaseDetail";

function App() {
  return (
    <div className="App dark">
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/casos/:id" element={<CaseDetail />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
